import GeoJSON from 'ol/format/GeoJSON';
import {getVectorContext} from 'ol/render';
import {useCallback, useMemo} from 'react';

function onPostcompose(event) {
  event.context.restore();
}

export function useClipCallbacks(geometry, style) {
  const onPrecompose = useCallback(
    event => {
      event.context.save();
      const vectorContext = getVectorContext(event);
      vectorContext.setStyle(style);
      vectorContext.drawGeometry(geometry);
      event.context.clip();
    },
    [geometry, style],
  );
  return [onPrecompose, onPostcompose];
}

export function useZoomCallback(view, updateView) {
  return useCallback(
    direction => {
      updateView({
        ...view,
        zoom: view.zoom + direction,
      });
    },
    [updateView, view],
  );
}

const format = new GeoJSON();
export function useMercatorGeometry(geometry) {
  return useMemo(() => {
    return format.readGeometry(geometry, {
      featureProjection: 'EPSG:3857',
    });
  }, [geometry]);
}
